import { apiGet } from "@/shared/api";

/**
 * Lane del sync engine fermata dal circuit breaker del supervisor
 * ("lane zombie"). Backend: ``GET /api/sync/halted-lanes``.
 *
 * Vuoto in condizioni normali; si popola quando una lane crasha
 * ripetutamente (5 crash in 60s) e il supervisor la ferma: lo stato è
 * persistito in ``app_meta`` (chiave ``sync_lane.<name>.halted``) e la lane
 * non riparte fino al restart del backend.
 */
export interface HaltedLane {
  /** Nome interno della lane (es. ``"sync worker[orders]"``). */
  lane: string;
  /** Motivo dell'arresto deciso dal breaker. */
  reason: string;
  /** Timestamp ISO (UTC) di quando la lane è stata fermata. */
  halted_at: string;
}

/**
 * Elenca le lane attualmente fermate dal supervisor.
 *
 * Thin wrapper su ``apiGet`` coerente con gli altri client del modulo.
 * Il chiamante è responsabile di validare la forma della risposta prima
 * di usarla (vedi ``HaltedLanesAlert``): non ci fidiamo del payload remoto.
 */
export function fetchHaltedLanes(init?: RequestInit): Promise<HaltedLane[]> {
  return apiGet<HaltedLane[]>("/api/sync/halted-lanes", init);
}
